import React from 'react';

const AsyncMailerPage = React.lazy(() => import('./MailerContainer'));

export const MailerPage = () => {
  return <AsyncMailerPage />;
};
